export const infraStructureConstants = {
	REQUEST_INFRASTRUCTURE: 'REQUEST_INFRASTRUCTURE',
	FAILURE_INFRASTRUCTURE: 'FAILURE_INFRASTRUCTURE',
	GET_INFRASTRUCTURE: 'GET_INFRASTRUCTURE',

	REQUEST_DELETE_INFRASTRUCTURE: 'REQUEST_DELETE_INFRASTRUCTURE',
	FAILURE_DELETE_INFRASTRUCTURE: 'FAILURE_DELETE_INFRASTRUCTURE',
	DELETE_INFRASTRUCTURE: 'DELETE_INFRASTRUCTURE',

	SET_NEW_INFRASTRUCTURE: 'SET_NEW_INFRASTRUCTURE',

	REQUEST_POST_INFRASTRUCTURE: 'REQUEST_POST_INFRASTRUCTURE',
	FAILURE_POST_INFRASTRUCTURE: 'FAILURE_POST_INFRASTRUCTURE',
	POST_INFRASTRUCTURE: 'POST_INFRASTRUCTURE',

	CLEAR_NEW_INFRASTRUCTURE: 'CLEAR_NEW_INFRASTRUCTURE',
	CLEAR: 'CLEAR',

	SET_NEW_ASSOCIATION: 'SET_NEW_ASSOCIATION',
	FAILURE_SET_NEW_ASSOCIATION: 'FAILURE_SET_NEW_ASSOCIATION',

	REQUEST_POST_ASSOCIATION: 'REQUEST_POST_ASSOCIATION',
	POST_ASSOCIATION: 'POST_ASSOCIATION',
	FAILURE_POST_ASSOCIATION: 'FAILURE_POST_ASSOCIATION',

	REQUEST_PUT_INFRASTRUCTURE: 'REQUEST_PUT_INFRASTRUCTURE',
	FAILURE_PUT_INFRASTRUCTURE: 'FAILURE_PUT_INFRASTRUCTURE',
	PUT_INFRASTRUCTURE: 'PUT_INFRASTRUCTURE',
	CLEAR_INFRASTRUCTURES: 'CLEAR_INFRASTRUCTURES',

	REQUEST_SET_DETAILS: 'REQUEST_SET_DETAILS',

	SET_DETAILS: 'SET_DETAILS',

	FAILURE_SET_DETAILS: 'FAILURE_SET_DETAILS',

	SET_PAGING: 'SET_PAGING',

	SET_FILTERS: 'SET_FILTERS',

	GET_LOCALS: 'GET_LOCALS',

	GET_OCCUPATION_AREA: 'GET_OCCUPATION_AREA',
	SET_DEFAULT_ASSOCIATIONS: 'SET_DEFAULT_ASSOCIATIONS',
	CLEAR_ASSOCIATIONS: 'CLEAR_ASSOCIATIONS',
	SET_UNIQUE_NEW_ASSOCIATION: 'SET_UNIQUE_NEW_ASSOCIATION',
	DELETE_DEFAULT_ASSOCIATION_SUCCESS: 'DELETE_DEFAULT_ASSOCIATION_SUCCESS',
	DELETE_NEW_ASSOCIATION_SUCCESS: 'DELETE_NEW_ASSOCIATION_SUCCESS',

	SET_ASSOCIATIONS_TO_UPDATE: 'SET_ASSOCIATIONS_TO_UPDATE',
	SEND_ASSOCIATIONS_TO_UPDATE: 'SEND_ASSOCIATIONS_TO_UPDATE',
	REQUEST_DEFAULT_ASSOCIATIONS: 'REQUEST_DEFAULT_ASSOCIATIONS',
	GET_ASSOCIATIONS_SUCCESS: 'GET_ASSOCIATIONS_SUCCESS'
};
